// assets
import { AiOutlineHome, AiOutlineUser, AiOutlineBank, AiOutlineDatabase, AiOutlineApi, AiOutlineMessage, AiOutlineWechatWork, AiOutlineConsoleSql } from 'react-icons/ai';

// ==============================|| MENU ITEMS - PAGES ||============================== //
const getCustomerServicePage = () => {
  return [
    {
      id: 'group-pages',
      title: 'Customer Services',
      type: 'group',
      children: [
        {
          id: 'customer-service-dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/customer-services/dashboard',
          icon: AiOutlineHome,
        },
        {
          id: 'customer-service-venues',
          title: 'Venues',
          type: 'item',
          url: '/customer-services/venues',
          icon: AiOutlineBank,
        },
        {
          id: 'customer-service-orders',
          title: 'Orders',
          type: 'item',
          url: '/customer-services/orders',
          icon: AiOutlineUser,
        },
        {
          id: 'customer-service-accounts',
          title: 'Accounts',
          type: 'item',
          url: '/customer-services/accounts',
          icon: AiOutlineUser,
        },
      ]
    },
    {
      id: 'super-admin',
      title: 'Super Admin',
      type: 'group',
      children: [
         {
          id: 'superadmin-apilogger',
          title: 'API Log',
          type: 'item',
          url: '/superadmin/dashboard/apilog',
          icon: AiOutlineApi,
        },
        {
          id: 'superadmin-orgsmslog',
          title: 'Venue SMS Log',
          type: 'item',
          url: '/superadmin/dashboard/orgsmslog',
          icon: AiOutlineWechatWork,
        },
        {
          id: 'superadmin-smslog',
          title: 'SMS Log',
          type: 'item',
          url: '/superadmin/dashboard/smslog',
          icon: AiOutlineMessage,
        },
        {
          id: 'superadmin-dbtables',
          title: 'Database Tables',
          type: 'collapse',
          icon: AiOutlineConsoleSql,
          children: [
            {
              id: 'superadmin-dbtables-baseactivitytypes',
              title: 'Base Activity Types',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/baseactivitytypes',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-country',
              title: 'Countries',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/country',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-cutoffdefinitions',
              title: 'Cut Off Definitions',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/cutoffdefinitions',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-membershipfeatures',
              title: 'Membership Features',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/membershipfeatures',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-milestonebadges',
              title: 'Milestone Badges',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/milestonebadges',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-orgsubslevels',
              title: 'Venue Subs Levels',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/orgsubslevels',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-subslevels',
              title: 'User Subs Levels',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/subslevels',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-superadmins',
              title: 'Super Admins',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/superadmins',
              icon: AiOutlineDatabase,
            },
            {
              id: 'superadmin-dbtables-vatrates',
              title: 'VAT Rates',
              type: 'item',
              url: '/superadmin/dashboard/dbtables/vatrates',
              icon: AiOutlineDatabase,
            },
          ]
        }
      ]
    }
  ];
};

export default getCustomerServicePage;